import { faTimes } from "@fortawesome/pro-light-svg-icons";
import StockFullCard from './StockFullCard.vue'
import StockFullCardMobile from './StockFullCardMobile.vue'
import ConfirmDialog from '../controls/ConfirmDialog.vue';
var ViewStockDialogMixin = {
    data() {
        return {
            dialog: false,
            stock: {},
            icons: {
                close: faTimes
            }
        }
    },
    components: {
        StockFullCard,
        StockFullCardMobile,
        ConfirmDialog
    },
    methods: {
        viewStock({ stock }) {
            this.stock = stock.stock;
            this.dialog = true;
        },
        close() {
            this.beforeClose()
        },
        closeDialog() {
            this.dialog = false
            this.$refs.stockFullCard.clear()
            this.stock = {}
        },
        scrollAndClose() {
            document.querySelector('#scrolling-techniques-6').scrollTop = 0;
            this.close();
        },
        beforeClose() {
            if (this.$store.getters.hasDirtyThresholds) {
                this.$refs.dirtyConfirmation.open({
                    title: this.$t('confirmation.dirty.title'),
                    text: this.$t('confirmation.dirty.text')
                })
            }
            else {
                this.closeDialog()
            }
        },
        dirtyConfirmationAnswered({ response }) {
            if (response) {
                this.$refs.stockFullCard.saveThresholds().then(() => {
                    this.$emit('notify', { type: 'success', text: this.$t('confirmation.saved'), duration: 3000 })
                    this.closeDialog()
                })
            }
            else {
                this.closeDialog()
            }
        }
    }
}

export default ViewStockDialogMixin
